import React from 'react'
import Footer from './Footer'
import { Outlet } from 'react-router-dom';
import HeaderAdmin from "./HeaderAdmin";

export default function OutletRouteAdmin() {
  return (
    <>
      <HeaderAdmin />
      <Outlet />
      <Footer />
    </>
  )
}
